import { Component, Input, OnChanges } from '@angular/core';
import * as _ from 'lodash';

import { BaseSegmentComponent } from '../base/_base-segment.component';


@Component({
  moduleId: module.id,
  selector: 'item-details-segment',
  templateUrl: 'item-details.component.html',
  styleUrls: ['item-details.component.scss'],
})
export class ItemDetailsComponent extends BaseSegmentComponent implements OnChanges {

  showMoreData: any = [];
  showMore: boolean = false;

  ngOnChanges() {
    this.data = this.orderBy(this.data);
  }

  // public
  public getItemProperty(item: any, path: string): any {
    switch (item.item_name) {
      case 'details.group.id':
        const groupName =  _.get(this.itemDetail, 'details.group.name', '');
        const groupCode =  _.get(this.itemDetail, 'details.group.code', '');
        if (groupName && groupCode) {
          return `${groupName} (${groupCode})`;
        } else if (groupName) {
          return groupName;
        } else if (groupCode) {
          return `(${groupCode})`;
        } else { return ''; }
      case 'details.group.subGroup.id':
        const subGroupName =  _.get(this.itemDetail, 'details.group.subGroup.name', '');
        const subGroupCode =  _.get(this.itemDetail, 'details.group.subGroup.code', '');
        if (subGroupName && subGroupCode) {
          return `${subGroupName} (${subGroupCode})`;
        } else if (subGroupName) {
          return subGroupName;
        } else if (subGroupCode) {
          return `(${subGroupCode})`;
        } else { return ''; }
      case 'details.core.id':
        return _.get(this.itemDetail, 'details.core.class', '');
      default:
        return super.getItemProperty(item, path);
    }
  }

}
